<template>
  <el-table
    :data="$props.accountContacts"
    stripe
  >
    <el-table-column
      label="Name"
      :min-width="180"
      show-overflow-tooltip
      :formatter="row => $_.get(row, 'name', '-') || '-'"
    />

    <el-table-column
      label="Type"
      show-overflow-tooltip
      :formatter="row => $_.get(row, 'contact_type.long', '-') || '-'"
    />

    <el-table-column
      label="Position"
      show-overflow-tooltip
      :formatter="row => $_.get(row, 'title', '-') || '-'"
    />

    <el-table-column
      label="Telephone"
      show-overflow-tooltip
    >
      <template v-slot="{ row }">
        <a :href="`tel:${row.phone}`">
          {{ $_.get(row, 'phone') || '-' }}
        </a>
      </template>
    </el-table-column>

    <el-table-column
      label="Mobile"
      show-overflow-tooltip
    >
      <template v-slot="{ row }">
        <a :href="`tel:${row.mobile}`">
          {{ $_.get(row, 'mobile') || '-' }}
        </a>
      </template>
    </el-table-column>

    <el-table-column
      label="Email"
      show-overflow-tooltip
    >
      <template v-slot="{ row }">
        <a :href="`mailto:${row.email}`">
          {{ $_.get(row, 'email') || '-' }}
        </a>
      </template>
    </el-table-column>

    <el-table-column
      label="Billing"
      align="center"
      :width="80"
    >
      <template v-slot="{ row }">
        <font-awesome-icon
          v-if="row.include_billing"
          :icon="['fal', 'check-circle']"
          fixed-width
          size="lg"
        />

        <template v-else>
          -
        </template>
      </template>
    </el-table-column>

    <el-table-column
      label="Pickups"
      align="center"
      :width="80"
    >
      <template v-slot="{ row }">
        <font-awesome-icon
          v-if="row.include_pickups"
          :icon="['fal', 'check-circle']"
          fixed-width
          size="lg"
        />

        <template v-else>
          -
        </template>
      </template>
    </el-table-column>

    <el-table-column
      v-if="!!$scopedSlots['actions']"
      label="Actions"
      align="right"
      :min-width="120"
    >
      <template v-slot="{ row, $index }">
        <slot
          name="actions"
          :account-contact="row"
          :account-contact-index="$index"
        />
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    accountContacts: {
      type: Array,
      required: true
    }
  }
}
</script>
